import type { FC, ReactElement, ReactNode } from 'react'

import './styles.scss'

export const RadioGroup: FC<{
  children: ReactNode
  id?: string
  label?: string | ReactElement
  className?: string
  containerClassName?: string
}> = ({ label, id, children, className = '', containerClassName = '' }) => (
  <div className={`radio-group ${className}`} role="radiogroup" aria-labelledby={id}>
    {label && (
      <span className="label mb-2 block" id={id}>
        {label}
      </span>
    )}

    <div className={`radio-buttons ${containerClassName}`}>{children}</div>
  </div>
)
